<template>
  <v-container class="page-content-wrapper pa-3">
    <v-tabs
      v-model="selectedTab"
      class="elevation-4 d-flex flex-column reports-tabs"
    >
      <v-tab v-for="tab in tabs" :key="'tab_' + tab.textKey" class="px-0">
        <span class="tab-title-wrapper">{{ $t(tab.textKey) }}</span>
      </v-tab>
      <v-tab-item
        v-for="tab in tabs"
        :key="'tab_item' + tab.textKey"
        class="tab-item"
      >
        <reports-overview
          :ref="tab.ref"
          :tab-data="tab.data"
        ></reports-overview>
      </v-tab-item>
    </v-tabs>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import ReportsOverview from "./ReportsOverview";

export default {
  title: "reports",
  name: "Reports",
  components: {
    ReportsOverview,
  },
  data() {
    return {
      selectedTab: 0,
    };
  },
  computed: {
    tabs() {
      const tabs = [
        {
          textKey: "dailyFinance",
          ref: "reportsDailyFinance",
          data: {
            level: 1,
            fileData: {
              icon: "$downloadPdf",
              type: "PDF",
              iconColor: "primary",
            },
            date: this.startDateDF,
          },
        },
        {
          textKey: "monthlyFinance",
          ref: "reportsMonthlyFinance",
          data: {
            level: 2,
            fileData: {
              icon: "$downloadPdf",
              type: "PDF",
              iconColor: "primary",
            },
          },
        },
        {
          textKey: "settlement",
          ref: "reportsSettlement",
          data: {
            level: 3,
            fileData: {
              icon: "$excel",
              type: "Excel",
              iconColor: "success",
            },
            date: this.startDateSM,
          },
        },
      ];
      return tabs;
    },
    ...mapState("reports", ["startDateDF", "startDateSM"]),
  },
};
</script>
